import React                from 'react';
import { useTranslate }     from '../../../hooks/use';

export const Footer = () => {
    const t = useTranslate();

    return (
        <footer className="application-footer">
            <div className="application-footer-desc">
                <h1>Hadi gelin danisarak halledelim.</h1>
                <p>Her sey sizin icin  - demirkan danismanlik</p>
                <button>bize ulas  🎉</button>
            </div>
            <div className="application-footer-social">
                <div className="linkedin"/>
                <div className="facebook"/>
                <div className="instagram"/>
                <div className="twitter"/>
            </div>
            <div style={{display:"flex", marginTop:"15px"}} >
                <div className="year">
                    &copy;
                    <span className="ml5">
                        { `${ new Date().getFullYear() }` }
                    </span>
                </div>
                <div className="year application-footer-policy">
                    <span>
                    Demirkan Danismanlik
                    </span>
                </div>
            </div>
        </footer>
    );
}
 
export default Footer;